import React from 'react'
import {
  View,
  Text,
  StyleSheet,
  ImageStyle,
  TouchableOpacity,
  TextStyle,
  StyleProp,
} from 'react-native'
import { BG_STYLES, COMMON_STYLES, LazyImage } from '@dehaat/dds'
import { Crop } from '../models/diagnosis'

export const checkIfCropExists = (list: Crop[], crop: Crop) => {
  if (list.length === 0) {
    return false
  }
  return list.some(item => {
    return item.crop_id === crop.crop_id
  })
}

interface Props {
  crop: Crop
  containerStyle?: Object
  imageContainerStyle?: Object
  activeImagecontainerStyle?: Object
  imageStyle?: ImageStyle
  textStyle?: Object
  isIcon?: boolean
  icon?: JSX.Element
  iconContainerStyle?: Object
  isDisabled?: boolean
  onClick?: (arg: Crop) => void
}

interface FallbackIconProps {
  text: string
  containerStyle?: StyleProp<ImageStyle>
  textStyle?: StyleProp<TextStyle>
}

export const FallbackIcon = ({
  text,
  containerStyle,
  textStyle,
}: FallbackIconProps) => {
  return (
    <View
      style={[
        BG_STYLES.bgWhite,
        COMMON_STYLES.alignItemsCenter,
        COMMON_STYLES.justifyCenter,
        styles.imageContainer,
        containerStyle,
      ]}
    >
      <Text style={[styles.fallbackTextStyle, textStyle]}>{text}</Text>
    </View>
  )
}

const RoundImageWithIcon = ({
  crop,
  containerStyle,
  imageContainerStyle,
  activeImagecontainerStyle,
  imageStyle,
  textStyle,
  isIcon,
  icon,
  iconContainerStyle,
  isDisabled = false,
  onClick,
}: Props) => {
  const handleClick = () => {
    if (onClick) {
      onClick(crop)
    }
  }

  return (
    <TouchableOpacity
      onPress={handleClick}
      disabled={isDisabled}
      style={[COMMON_STYLES.alignItemsCenter, containerStyle]}
    >
      <View>
        {isIcon ? (
          <View style={iconContainerStyle}>{icon ? icon : null}</View>
        ) : null}
        <View
          style={[
            styles.imageContainer,
            imageContainerStyle,
            isIcon ? activeImagecontainerStyle : null,
          ]}
        >
          <LazyImage
            imageUrl={crop.crop_image}
            fallBackIcon={
              <FallbackIcon
                text={crop.crop_name_local}
                containerStyle={imageStyle}
              />
            }
            imgStyles={[BG_STYLES.bgWhite, imageStyle]}
          />
        </View>
      </View>
      <Text numberOfLines={1} style={[COMMON_STYLES['mt1/4'], textStyle]}>
        {crop.crop_name_local}
      </Text>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  imageContainer: {
    overflow: 'hidden',
    borderRadius: 9999,
  },
  fallbackTextStyle: {
    fontSize: 20,
    fontWeight: '800',
  },
})

export default RoundImageWithIcon
